// import { useEffect, useState } from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import 'react-vertical-timeline-component/style.min.css';

import "./Learnings.css";

const Learning = () => {

    // const [height, setHeight] = useState();
    const timeLineData = [
        {
            id: 1,
            title: "UG degree in Computer Science and Engineering",
            subtitle: "Sri Shakthi School of Engineering and Technology",
            discretion: "I am currently doing my under graduate degree of computer science and engineering in Sri Shakthi Institute.",
            date: "Batch 2022 - 2026",
        },
        {
            id: 2,
            title: "Schooling and Higher Education",
            subtitle: "Orison Academy",
            discretion: "I complied my lower studies and higher studies in schooling at Orison Academy - CBSE.",
            date: "2010 - 2022",
        },
    ];

    return (<section id="learning" className="learning">
        <h1>Embracing Knowledge</h1>
        <VerticalTimeline layout="1-column-left" lineColor="#7808d0">
            {timeLineData.map((element) => {
                return <VerticalTimelineElement
                    key={element.id}
                    className="vertical-timeline-element--education"
                    date={element.date}
                    iconStyle={{ left: '15px', height: '40px', width: '10px', borderRadius: "10px", background: '#7808d0', color: '#7808d0', outlineColor: '#7808d0', borderColor: '#7808d0' }}
                    contentArrowStyle={{ display: 'none' }}
                    contentStyle={{ boxShadow: 'none', backgroundColor: '#eee' }}
                >
                    <h3 className="vertical-timeline-element-title">{element.title}</h3>
                    <h4 className="vertical-timeline-element-subtitle">{element.subtitle}</h4>
                    <p>
                        {element.discretion}
                    </p>
                </VerticalTimelineElement>
            })}
        </VerticalTimeline>
        <br />
        <br />
        <br />
    </section>
    );
}

export default Learning;
